<template>
  <!-- prettier-ignore -->
  <label :class="classes">
    <input
      class="radio__input"
      type="radio"
      v-bind="$attrs"
      v-on="$listeners"
      :checked="checked"
      :disabled="disabled"
      :name="name"
      @click="emitUpdate"
    />

    <ovp-icon
      class="radio__icon"
      :art="icon.art"
      :name="icon.name"
    />

    <div class="radio__label"><slot /></div>
  </label>
</template>

<script>
/**
 * We need both values from the radio input field and from the group
 */
export default {
  name: 'OvpRadio',

  inheritAttrs: false,

  model: {
    prop: 'input',
    event: 'update'
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    input: {
      type: [String, Number, Boolean],
      default: null
    },

    name: {
      type: String,
      required: true
    },

    theme: {
      type: String,
      default: 'light'
    }
  },

  computed: {
    checked() {
      return this.input === this.$attrs.value
    },

    classes() {
      return {
        radio: true,
        'radio--selected': this.checked,
        'radio--disabled': this.disabled,
        [`radio--${this.theme}`]: true
      }
    },

    icon() {
      return {
        art: this.checked ? 'solid' : 'regular',
        name: 'circle'
      }
    }
  },

  methods: {
    emitUpdate(event) {
      if (!this.checked) {
        this.$emit('update', event.target.value)
      }
    }
  }
}
</script>

<style name="mobile" scoped>
.radio {
  cursor: pointer;
  display: inline-block;
  position: relative;
  font-size: 15px;
  line-height: 20px;
  color: var(--c-black);

  .radio__icon {
    position: absolute;
    top: 3px;
    font-size: 16px;
    color: var(--c-black);
  }

  .radio__input {
    pointer-events: none;
    position: absolute;
    opacity: 0;

    &:focus ~ .radio__label {
      color: var(--c-original-green);
    }
  }

  .radio__label {
    padding-left: 20px;
    user-select: none;
  }

  &:hover,
  &:hover .icon {
    color: var(--c-original-green);
  }

  &--selected {
    .icon {
      color: var(--c-original-green);
    }
  }

  &--dark {
    .radio {
      .radio__label,
      .radio__icon {
        color: var(--c-white);
      }
    }
    &.radio--selected {
      .icon {
        color: var(--c-original-green);
      }
    }
  }

  &--disabled {
    opacity: 0.5;
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .radio {
  }
}
</style>